module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Update-dbabf157e835c5287bf6c8a3e15207f5.svg";